import React from 'react'
import { theme } from "antd";
import { Footer } from 'antd/es/layout/layout';
const { useToken } = theme;

export default function FooterComponent() {
    const { token } = useToken();
  return (
    <Footer style={{backgroundColor: '#05204e'}}>

    </Footer>
  )
}
